module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("For my grandmother Alice Cahill Moore; my parents, Jack and Anne; and my father’s great-aunt, Miss Aggie Blake")]), _vm._v(" "), _c('p', {
    staticClass: "dedicationt"
  }, [_vm._v("Growing up in Atlanta, I would often hear people say, “Your father has an unusual accent; where is he from?”")]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_vm._v("May this story provide an answer.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-522e4158","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/dedication.vue
// module id = 78
// module chunks = 0